export const config = {
    appId: '07abb866-f098-439c-af3a-6446f66cfaea',
    redirectUri: 'https://app.djupbla.ai/',
    scopes: [
        'DJUPBLA.Access'
    ],
    authority: 'https://login.microsoftonline.com/4e417dd5-a86b-431f-9965-4e7c69ea697e/'
}